import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'ba-reset-unavailable',
  template: `
    <mat-card class="main-container">
      <mat-card-header>
        <mat-card-title class="header-logo">
          <img src="/assets/images/logo.png" alt="biome-logo" />
        </mat-card-title>
        <mat-card-title class="header-title">
          <h3 class="title">Password/Username Reset</h3>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <br />
        <div>
          <span>
            Password and username reset is only available at
            <a
              href="https://app.biome.io/"
              target="_blank"
              rel="noopener noreferrer"
            >
              app.biome.io
            </a>
          </span>
        </div>
        <br />
        <button
          mat-raised-button
          color="primary"
          data-ba-id="backToLogin"
          routerLink="/login"
        >
          Back to Login
        </button>
        <div class="info-box">
          If you need further assistance, please reach out to
          <a href="mailto:support@biome.io">support&#64;biome.io</a>.
        </div>
      </mat-card-content>
    </mat-card>
  `,
  styleUrls: ['./reset-unavailable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCardModule, MatIconModule, RouterLink, MatButtonModule],
})
export class ResetUnavailableComponent {}
